module.exports = __webpack_public_path__ + "img/m6.3b74cdd1.png";